export default "__VITE_ASSET__DwugrEPC__"